export const mapToLabel = (opt: { id?: number; name?: string } | undefined) => ({
  label: opt?.name,
  ...opt,
});

export const toggleElements = (el: any, arr: any, mutateArr = false) => {
  let newArr = mutateArr ? arr : [...arr];

  if (newArr.includes(el)) {
    newArr.splice(newArr.indexOf(el), 1);
  } else {
    newArr.push(el);
  }

  return newArr;
};

export const checkAvailability = (arr?: any[], el?: any) => {
  return arr?.some((v) => v === el);
};

export const toggleElementsById = <T extends { id: number }>(
  el: T,
  arr: T[],
  mutateArr = false
) => {
  let newArr = mutateArr ? arr : [...arr];
  const matchedIndex = newArr.findIndex((v) => v?.id === el?.id);

  if (matchedIndex > -1) {
    newArr.splice(matchedIndex, 1);
  } else {
    newArr.push(el);
  }

  return newArr;
};

export const checkAvailabilityById = (arr = [], el: any) => {
  return arr?.some((v) => (v as any)?.id === el);
};

export const getSumByKey = (arr = [], key = "") => {
  return arr?.reduce((acc, curr) => acc + curr[key], 0);
};

export const ascendingSort = <T>(arr: T[] = [], key = "") => {
  if (key === "") return arr?.sort((a, b) => a - b);

  return arr?.sort((a, b) => a[key] - b[key]);
};

export const insert = (arr = [], index = 0, newItem = null) => [
  ...arr.slice(0, index),
  newItem,
  ...arr.slice(index),
];

export const checkUniqueness = (arr = []) => {
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  if (Array.isArray()) return -1;

  const uniqueArray = [...new Set(arr)];

  return uniqueArray?.length === arr?.length;
};

export const splitArray = (arr: any[] = [], chunkSize: number) => {
  const chunks = [];

  for (let i = 0; i < arr.length; i += chunkSize) {
    const chunk = arr.slice(i, i + chunkSize);
    chunks.push(chunk);
  }

  return chunks;
};
